import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { jwtDecode } from 'jwt-decode'
import Cookies from 'js-cookie'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: DecodedToken | null
  setTokens: (access: string, refresh: string) => void
  clearTokens: () => void
}

interface DecodedToken {
  company_code: string
  email: string
  name: string
  program_code: string
  type: string
  created_at: string
  sub: string
  exp: number
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setTokens: (access, refresh) => {
        try {
          const decoded = jwtDecode<DecodedToken>(access)
          console.log('[USER] decoded', decoded)
          set({ accessToken: access, refreshToken: refresh, user: decoded })
        } catch (error) {
          console.error('JWT decode error:', error)
          set({ accessToken: access, refreshToken: refresh, user: null })
        }
      },
      clearTokens: () => {
        Cookies.remove('axp_access_token')
        Cookies.remove('axp_refresh_token')
        set({ accessToken: null, refreshToken: null, user: null })
      },
    }),
    {
      name: 'auth-storage',
      // 성능 최적화 설정
      partialize: state => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
      onRehydrateStorage: () => state => {
        // 토큰이 있으면 user 정보를 다시 디코딩
        if (state?.accessToken) {
          try {
            const decoded = jwtDecode<DecodedToken>(state.accessToken)
            const now = Math.floor(Date.now() / 1000)
            if (decoded.exp && decoded.exp < now) {
              state.user = null
              state.accessToken = null
              state.refreshToken = null
              Cookies.remove('axp_access_token')
              Cookies.remove('axp_refresh_token')
            } else {
              state.user = decoded
            }
          } catch (error) {
            console.error('JWT decode error on rehydrate:', error)
            state.user = null
          }
        }
      },
    },
  ),
)
